module.exports = __webpack_public_path__ + "static/media/AgendaCultural.9194da5b.png";